import { TInsuredNew } from 'Constants/groupTypes'

export const MemberSelectionInitials: TInsuredNew[] = [
  { id: '1', type: 'Self', name: 'Self', age: '', arr: [] },
  {
    id: '2',
    type: 'Spouse',
    name: 'Spouse',
    age: '',
    arr: [],
  },
  {
    id: '3',
    type: 'Mother',
    name: 'Mother',
    age: '',
    arr: [],
  },
  {
    id: '4',
    type: 'Father',
    name: 'Father',
    age: '',
    arr: [],
  },
  {
    id: '5',
    type: 'Son',
    name: 'Son',
    age: '',
    arr: [],
  },
  {
    id: '6',
    name: 'Daughter',
    type: 'Daughter',
    age: '',
    arr: [],
  },
]
export const FinalSelectionInitials = [
  {
    dob: '',
    name: '',
    type: '',
    uuid: '',
  },
]
export const childCountInitials = {
  son: 0,
  daughter: 0,
}
